module.exports = __webpack_public_path__ + "static/media/home_avatar4.8a5143fa.png";